export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <p className="card__description-title">
                    Загальна характеристика
                </p>
                <p className="card__description-text">
                    СТАРК 7+ СУМО (НС 8004) — це сучасний високопродуктивний гібрид соняшнику з підвищеною стійкістю до стресових факторів та максимальним рівнем захисту від вовчка. Гібрид поєднує стабільну врожайність, витривалість та високу адаптивність до різних умов вирощування.
                </p>
                <p className="card__description-text">
                    Завдяки технології SUMO®, СТАРК 7+ забезпечує ефективний контроль бур’янів та стабільну реалізацію потенціалу навіть у складних агрокліматичних умовах.
                </p>
                <p className="card__description-title">Основні переваги</p>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Потенціал урожайності — до 5,5 т/га</li>
                    <li className="card__description-numbering">Висока стійкість до стресових умов</li>
                    <li className="card__description-numbering">Стійкість до вовчка — 7+ рас (A–G+)</li>
                    <li className="card__description-numbering">Стійкість до всіх рас несправжньої борошнистої роси</li>
                    <li className="card__description-numbering">Стабільний результат у різних умовах вирощування</li>
                    <li className="card__description-numbering">Висока адаптивність</li>
                </ol>
                <table className="card__description__table">
                    <tr>
                        <td className="card__description__td">Період вегетації</td>
                        <td className="card__description__th-index">105–107 днів</td>
                    </tr>
                    <tr>
                        <td className="card__description__td">Олійність:</td>
                        <td className="card__description__th-index">51–53%</td>
                    </tr>
                    <tr>
                        <td className="card__description__td card__description__td--link">Висота рослин</td>
                        <td className="card__description__th-index">175–195 см</td>
                    </tr>
                </table>
                <p className="card__description-title">
                    Рекомендації по густоті
                </p>
                <ol className="card__description-list">
                    <li className="card__description-numbering">За достатнього зволоження: 60–65 тис. рослин/га</li>
                    <li className="card__description-numbering">У посушливих умовах: 45–50 тис. рослин/га</li>
                </ol>
                <div className="card__description-title">Стійкість та толерантність</div>
                <ol className="card__description-list">
                    <p className="card__description-text">
                        Стійкість:
                    </p>
                    <li className="card__description-numbering">Посухостійкість, вилягання — 9/10</li>
                    <li className="card__description-numbering">Холодостійкість — 8/10</li>
                    <p className="card__description-text">
                        Толерантність до хвороб:
                    </p>
                    <li className="card__description-numbering">Вугільна гниль, біла гниль, пероноспороз — 9/10</li>
                    <li className="card__description-numbering">Іржа, сіра гниль, септоріоз, фомоз, альтернаріоз — 8/10</li>
                    <li className="card__description-numbering">Фомопсис — 7/10</li>
                </ol>
                <div className="card__description-title">Рекомендовані зони вирощування</div>
                <p className="card__description-text">
                    Гібрид підходить для вирощування у всіх зонах України, особливо ефективний у Степу та Лісостепу, де важлива стійкість до стресів і стабільність врожаю.
                </p>
                <div className="card__description-title">Рекомендації щодо вирощування</div>
                <p className="card__description-text">
                    СТАРК 7+ СУМО добре реагує як на інтенсивні технології, так і на вирощування в умовах обмеженого вологозабезпечення. Рекомендується застосування гербіцидів системи SUMO® (Експрес + ПАР Тренд).
                </p>
                <p className="card__description-text">
                    Гібрид підходить для господарств, які прагнуть мінімізувати ризики та отримати стабільний результат.
                </p>
                <p className="card__description-text">
                    СТАРК 7+ СУМО — це гібрид для тих, хто хоче максимальну надійність і захист від вовчка. Ідеальний варіант для зон з високим рівнем стресів та складними умовами вирощування.
                </p>
            </div>
            <div className="card__description-preference">
                <div className="aside__title--new">Головні переваги</div>
                <div className="asede__head">
                    <div className="aside__block">Високий потенція урожайності</div>
                    <div className="aside__block">Найкращу віддачу забезпечує на родючих грунтах</div>
                    <div className="aside__block">Один із найбільш високоврожайних гібридів з високим вмістом олії</div>
                </div>
            </div>
        </div>
    );
}
